exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v--modal-overlay[data-modal=rules-modal-step5] {\n  background-color: rgba(0, 0, 0, 0.88) !important;\n}\n.v--modal-overlay[data-modal=rules-modal-step5] .v--modal-box {\n  background-color: transparent;\n  max-width: 100%;\n}\n.v--modal-overlay[data-modal=rules-modal-step5] .v--modal {\n  border-radius: 2px;\n  box-shadow: none;\n}", ""]);

// exports
